<div class="project-opportunities">
    <app-project-library-items [projectDetails]="projectDetails" [libraryType]="libraryType" (projectDetailsChanged)="opportunityDetailsChanged($event)"></app-project-library-items>
</div>
